<template>
    <Loading :loading="loading" :text="$t('receive_mail_for_password_reset') + '...'">
        <form v-if="user.token" @submit.prevent="resetPassword()">
            <Input type="text" name="email" :formComponentId="this.$.uid" :required="true" :label="$t('mail')" v-model:value="user.email" autocomplete="new-password" class="my-4">
            </Input>
            <Input
                type="password"
                name="password"
                :formComponentId="this.$.uid"
                :required="true"
                :label="$t('new_password')"
                v-model:value="user.password"
                autocomplete="new-password"
                class="my-4"
                :strengthMeter="true"
            >
            </Input>
            <Input
                type="password"
                name="password_confirmation"
                :formComponentId="this.$.uid"
                :required="true"
                :label="$t('confirm_password')"
                v-model:value="user.password_confirmation"
                autocomplete="new-password"
                class="my-4"
            >
            </Input>
            <FormButton type="submit" class="my-6" :formComponentId="this.$.uid" styling="primary flex items-center gap-3" :value="$t('reset_password')" :disabled="loading">
                <FontAwesomeIcon
                    v-show="loading"
                    :icon="['fas', 'circle-notch']"
                    class="animate-spin text-white transition-all ease-in-out duration-300 w-0"
                    :class="loading ? 'w-10' : ''"
                >
                </FontAwesomeIcon>
            </FormButton>
        </form>
    </Loading>
</template>

<script>
import i18next from 'i18next';

export default {
    data: () => ({
        user: {},
        loading: false
    }),

    mounted() {
        this.user.token = this.$route.params.token;
        this.user.email = this.$route.query.email;
    },

    methods: {
        resetPassword() {
            this.$store.commit('error/unsetByComponentId', this.$.uid);
            this.user.config = { componentId: this.$.uid };
            this.$store
                .dispatch('user/reset_password', this.user)
                .then(() => {
                    setTimeout(() => {
                        this.loading = false;
                        this.$toast.success(i18next.t('password_succesfull_reset'));
                        this.$router.push('/login');
                    }, 2000);
                })
                .catch(() => {
                    setTimeout(() => {
                        this.loading = false;
                        this.$toast.error(i18next.t('password_error_reset'));
                    }, 2000);
                });
        }
    }
};
</script>
